export default {
      id: "color_blue_pointer-usage",
      viewBox: "0 0 68 95",
      url: __webpack_public_path__ + "sprite.svg#color_blue_pointer",
      toString: function () {
        return this.url;
      }
    }